import { Modal } from "@/components/ui/customs/modal";
import { Button } from "@/components/ui/button";
import { getExpeditionIdentifier } from "@/lib/expedition.util";
import { GetAllExpeditionResponseDtoExpedition } from "@/types/api/api-types";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";

type Props = {
  expedition: GetAllExpeditionResponseDtoExpedition;
  open: boolean;
  onClose: () => void;
  deleteExpedition: (id: string) => Promise<unknown>;
  isDeletionPending: boolean;
};

export const DeleteExpeditionModal = ({
  expedition,
  open,
  onClose,
  deleteExpedition,
  isDeletionPending,
}: Props) => {
  const { t } = useTranslation(["boExpeditions", "common"]);
  const expeditionIdentifier = getExpeditionIdentifier(expedition) ?? "";

  const handleDelete = async () => {
    await deleteExpedition(expedition.id);
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      dismissible={!isDeletionPending}
      contentClassName="max-w-[500px]"
      title={t("pendingShipmentsDeleteModal.title")}
      description={t("pendingShipmentsDeleteModal.description", { expeditionIdentifier })}
      footer={
        <div className="flex w-full gap-2">
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={isDeletionPending}
            className="flex-1"
          >
            {t("common:actions.cancel")}
          </Button>
          <Button
            type="button"
            variant="destructive"
            onClick={handleDelete}
            disabled={isDeletionPending}
            className="flex-1"
          >
            {isDeletionPending ? <Loader2 className="animate-spin" /> : t("common:actions.confirm")}
          </Button>
        </div>
      }
    />
  );
};
